import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";

const Profile = () => {
  const [user, setUser] = useState("undefined");

  useEffect(() => {
    if (Cookies.get("user") !== undefined) {
      setUser(JSON.parse(Cookies.get("user")));
    }

    console.log(user);
  }, []);
  return (
    <React.Fragment>
      <div className="h-screen mb-4">
        <div className="flex relative min-w-0 break-words bg-white mb-6 shadow-lg rounded-xl mt-16">
          <img
            className="object-cover w-full h-96 rounded-t-lg md:h-auto md:w-48 md:rounded-none md:rounded-l-lg"
            src={user.image_url}
            alt=""
          />
          <div className="flex flex-col justify-between p-4 leading-normal">
            <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
              {user.name}
            </h5>
            <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
              {user.email}
            </p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Profile;
